<!-- Универсальный шаг вопроса да/нет из snapshot шаблона. -->
<template>
  <VehicleInspectionStepLayout :title="step.name" :description="step.description" centered>
    <template #actions>
      <base-primary-button size="large" :disabled="disabled" @click="answer(true)">
        {{ step.config?.yes_label || "Да" }}
      </base-primary-button>
      <base-button size="large" :disabled="disabled" @click="answer(false)">
        {{ step.config?.no_label || "Нет" }}
      </base-button>
    </template>
  </VehicleInspectionStepLayout>
</template>

<script>
import VehicleInspectionStepLayout from "@/components/Vehicle/Inspection/Step/Layout.vue";

export default {
  name: "VehicleInspectionStepQuestion",
  components: { VehicleInspectionStepLayout },
  props: {
    step: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  emits: ["complete"],
  methods: {
    answer(value) {
      this.$emit("complete", { value: { answer: value } });
    },
  },
};
</script>
